import { ButtonGroup } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '../useEarningsInsightDrawer';
import { EarningsPreview } from './earnings-preview/EarningsPreview';
import { EarningsRecap } from './earnings-recap/EarningsRecap';
import * as S from './EarningsInsightWidget.styles';

export const EarningsInsightWidget = () => {
  const { t } = useTranslation(['earnings']);
  const { switchTab, activeTabIndex, activeTab } = useEarningsInsightDrawer();

  return (
    <S.Root>
      <ButtonGroup
        labels={[
          t('earnings:earningsInsight.drawer.earningsPreview.title'),
          t('earnings:earningsInsight.drawer.earningsRecap.title'),
        ]}
        onClick={switchTab}
        activeIndex={activeTabIndex}
      />
      {activeTab === SubTabsType.Preview ? (
        <EarningsPreview />
      ) : (
        <EarningsRecap />
      )}
    </S.Root>
  );
};
